export const SHITCOIN_BLACKLIST = new Set<string>(
    [
        '0x0b91b07beb67333225a5ba0259d55aee10e3a578', //MNEP
        '0xE81A79e9d951759aeF3FcceF17022276b3A0C7E5', // Momentum (BSC)
        // '0x20f663CEa80FaCE82ACDFA3aAE6862d246cE0333', // Drip Token (BSC)
        '0x035de3679E692C471072d1A09bEb9298fBB2BD31', // Wormhole BUSD
        '0x418D75f65a02b3D53B2418FB8E1fe493759c7605', // Wormhole bnb (mainnet)
        '0xE5bA47fD94CB645ba4119222e34fB33F59C7CD90', // Safuu (BSC)
        '0x9a3321E1aCD3B9F6debEE5e042dD2411A1742002', // PIGS (BSC)
        '0x42981d0bfbAf196529376EE702F2a9Eb9092fcB5', // SAFEMOON (BSC)
        '0xa86d305A36cDB815af991834B46aD3d7FbB38523', // BR34P (BSC)
        '0x0F1cBEd8EFa0E012AdbCCB1638D0aB0147D5Ac00', // HELLO (BSC)
    ].map((addr) => addr.toLowerCase())
)
